import { render, staticRenderFns } from "./MoneyRequestWithoutManageAccess.vue?vue&type=template&id=67a543ed"
import script from "./MoneyRequestWithoutManageAccess.vue?vue&type=script&lang=js"
export * from "./MoneyRequestWithoutManageAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports